'use strict';

require('pages/article/index.scss');

//嵌入模板属性
(function () {
  return {
    title: '文章'
  };
})();


//////////////////
// WEBPACK FOOTER
// ./src/router/article.js
// module id = v1NtlgFt
// module chunks = 3